// Exposes jQuery on the global scope BEFORE any jQuery plugin is imported.
// Several legacy plugins (Fancybox 3, jquery-zoom) are bare IIFEs that
// reference `window.jQuery` at module-evaluation time. Because ES module
// imports are hoisted, plain `window.jQuery = ...` assignments in a
// consumer's module body run AFTER its imports — too late. This shim must
// be the first import in any file that pulls in those plugins.
import jQuery from "jquery";

// biome-ignore lint/suspicious/noExplicitAny: jQuery globals are intentionally untyped here
(globalThis as any).jQuery = jQuery;
// biome-ignore lint/suspicious/noExplicitAny: jQuery globals are intentionally untyped here
(globalThis as any).$ = jQuery;
